import { IApiActionResult } from './ApiActionResult';

export const fetchGet = 
    async (requestUrl: string, requestOptions?: RequestInit): Promise<Response> => {
        return await fetch(requestUrl, {
            ...requestOptions,
            method: 'GET',
        });
}

export const getApiActionResult = 
    async <T>(
        fetchPromise: Promise<Response>,
        hasReturnValue: boolean = false,
        isJson: boolean = true, 
    ): Promise<IApiActionResult<T>> => {
        let statusCode: number = 0;
        try {
            const response: Response = await fetchPromise;
            statusCode = response.status;

            if(response.ok) {
                let value: any = {}; 
                if(response.status !== 204) {
                    value = hasReturnValue ? 
                    (isJson ? await response.json() : await response.text()) : 
                    null;
                }
                return { isSuccess: true, value, statusCode };
            } else {
                return { isSuccess: false, statusCode }
            }
        }
        catch(ex) {
            console.log(ex);
            return { isSuccess: false, statusCode };
        }
}